import React from 'react';
import styled from '@emotion/styled';

import { Container } from 'components/layout';

const FooterStyled = styled.div`
  width: 100%;
  min-height: 150px;
  background-color: ${({ theme }) => theme.colors.footerBackground};
  font-size: 15px;
  margin-top: 3.55rem;

  & span {
    margin: 20px 15px;
    width: 33.33%;
  }

  & a {
    color: #fff;
    text-decoration: none;
  }

  & a:hover {
    text-decoration: underline;
  }
`;

const FooterContainer = styled(Container)`
  display: flex;
  padding: 0 20px;
`;

const Link = styled.a`
  color: #fff;
  text-decoration: none;
  margin-top: 20px;
`;

const Footer = () => {
  return (
    <FooterStyled>
      <FooterContainer>
        <span>
          <Link href="https://www.calix.com/pages/terms-of-use.html">
            © Calix | All Rights Reserved
          </Link>
        </span>
        <span>
          <Link href="https://www.calix.com/pages/terms-of-use.html">Terms and Conditions</Link>
        </span>
        <span>
          <Link href="https://www.calix.com/pages/terms-of-use.html">Privacy Policy</Link>
        </span>
        <span id="trust-arc-placeholder" />
      </FooterContainer>
    </FooterStyled>
  );
};

export { Footer };
